import Scrrroll from 'scrrroll';
import {easeOutQuart} from 'easings.js';

Scrrroll.duration = 1500;
Scrrroll.easing = easeOutQuart;

export default function (dom, opts) {
  let options = {
    deeplink: false,
    ...opts
  };

  const html = document.documentElement;
  const targetSelector = options.selector || dom.getAttribute('href');
  let target;

  try {
    if (targetSelector === '#') {
      options.top = true;
    }
    else {
      target = document.querySelector(targetSelector);
    }
    if (target || options.top) {
      dom.addEventListener('click', async e => {
        e.preventDefault();

        html.classList.remove('show--nav'); // close nav when clicking a scroll link

        if (options.top) {
          await Scrrroll.toTop();
          window.location.hash = '';
        }
        else {
          await Scrrroll.to(target);

          if (/^#/.test(targetSelector) && opts.deeplink) {
            window.location.hash = targetSelector;
          }
        }
        return false;
      });
    }
  }
  catch(error) {
    // well, then it does nothing ;)
  }

}
